<template>
  <ClientOnly>


    <div
    class="modal modalFade userModels reportRateModal warning_modal"
    id="warning_modal"
    tabindex="-1"
    aria-labelledby="userModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title" id="userModalLabel">{{modalTitle}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <!-- Modal Body -->
        <div class="modal-body">
          <div class="icon_wrap mb-3">
              <i class="fi-rr-flag"></i>
            </div>
            <h3 class="text_1">{{ firstText }}</h3>
            <p class="text_2">{{ secondText }}</p>
       
        </div>
        <!-- End Modal Body -->
      </div>
    </div>
  </div>

  </ClientOnly>
</template>

<script setup>
import { useWarningModal } from "~/composables/useWarningModal";

const {
  showModal,
  modalTitle,
  firstText,
  secondText,
  hideModal,
} = useWarningModal();
</script>

<style scoped>
.reportRateModal{
  z-index: 9999999;
}
</style>
